

<template>
  <div class="category_filter_option">
    <div>
      <div class="choose_header">
        <span class="back">
          <i class="material-icons" @click="goBack()">keyboard_backspace</i> {{$t('filter')}}
        </span>
        <span @click="clearFilter">{{$t('clearFilter')}}</span>
    </div> <div class="filter_list">
        <div class="cat_wrap">
          <ul class="category_tab">
            <li
              v-for="(filterItem,index) in filterOption"
              :key="index"
              :class="{'active':index == filterIndex}"
            >
              <span @click="getFilterItem(index)">{{filterItem}}</span>
            </li>
          </ul>
          <div class="rght_tab">
            <div class="cata_row" v-show="showFilterItem">
              <ul>
                <li
                  class="prod_gallry_col1"
                  v-for="(products, index) in details.categoryFilterDTOs"
                  :class="getSelectedCategory(products.categoryId)"
                  :key="index"
                >
                  <input type="radio" id="under100" name="drone" value="under100" checked />
                  <label
                    for="under100"
                    @click="chooseCategory(products.categoryId,products.displayName )"
                  >{{products.displayName}}</label>
                </li>
              </ul>
            </div>
            <div class="cata_row" v-show="!showFilterItem">
              <ul>
                <li
                  class="prod_gallry_col1"
                  v-for="(products,index) in details.priceFilterDTOs"
                  :class="getSelectedPrice(index)"
                  :key="index"
                >
                  <input type="radio" id="under100" name="drone" value="under100" checked />
                  <label
                    for="under100"
                    @click="choosePrice(products.minPrice,products.maxPrice,index)"
                  >रु {{products.minPrice}} से रु {{products.maxPrice}}</label>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="choose_footer">
        <button class="btn_filter blue" @click="applyFilter()">{{$t('apply')}}</button>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import PriceRange from "../Common/PriceRange"
export default {
  name: "CategoryFilterOption",
  components: {
    PriceRange
  },
  props: {
    dataValue: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      selectFilterCategory: null,
      selectFilterPrice: null,
      choosedOption: false,
      minPrice: null,
      maxPrice: null,
      choosedCateName: "",
      details: {},
      filterOption: ["Category", "Price"],
      filterIndex: 0,
      showFilterItem: true
    };
  },
  watch: {
    dataValue() {
      this.details = this.dataValue;
    }
  },
  methods: {
    getFilterItem(index) {
      this.showFilterItem = !this.showFilterItem;
      this.filterIndex = index;
    },
    getSelectedPrice(selectFilterPrice) {
      if (this.selectFilterPrice == selectFilterPrice) {
        return "choosed_option";
      }
    },
    choosePrice(min, max, selectFilterPrice) {
      if (parseInt(this.selectFilterPrice) === parseInt(selectFilterPrice)) {
        return;
      }
      this.selectFilterPrice = selectFilterPrice;
      this.minPrice = min;
      this.maxPrice = max;
    },
    getSelectedCategory(selectFilterCategory) {
      if (this.selectFilterCategory == selectFilterCategory) {
        return "choosed_option";
      }
    },
    chooseCategory(selectFilterCategory, name) {
      if (
        parseInt(this.selectFilterCategory) === parseInt(selectFilterCategory)
      ) {
        return;
      }
      this.choosedCateName = name;
      this.selectFilterCategory = selectFilterCategory;
    },
    goBack() {
      this.$emit("closeAllCat");
    },
    applyFilter() {
      if (this.selectFilterCategory || this.minPrice || this.maxPrice) {
        const obj = {
          categoryId: this.selectFilterCategory,
          minPrice: this.minPrice,
          maxPrice: this.maxPrice,
          choosedCateName: this.choosedCateName
        };
        this.$emit("getFilterList", obj);
      } else {
        this.$emit("closeAllCat");
      }
    },
    clearFilter() {
      (this.selectFilterCategory = null),
        (this.minPrice = null),
        (this.maxPrice = null),
        (this.selectFilterPrice = null);
    },
    getMinPrice(value){
      this.minPrice = value
    },
    getMaxPrice(value){
      this.maxPrice = value
    }
    
  },
  mounted() {
    this.details = this.dataValue;
  },
  computed: {}
};
</script>
